import { ApiError } from '@/lib/api/client';

const MESSAGE_ERRORS: Record<string, string> = {
  conversation_not_found:
    'That Healthie conversation is no longer available. Refresh the patient chart and try again.',
  clinician_healthie_identity_required:
    'Your clinician account is not linked to a Healthie provider.',
  clinician_healthie_credential_required:
    'Your Healthie authoring credential is not configured.',
  clinician_healthie_credential_mismatch:
    'Your clinician account is linked to the wrong Healthie credential.',
  clinician_message_delivery_failed:
    'Healthie did not accept the message. Nothing was posted; refresh and try again.',
  claimed_by_other: 'A colleague claimed this conversation — reply not sent.',
};

export function clinicianMessageError(
  error: unknown,
  fallback = 'Message could not be sent. Nothing was posted.',
): string {
  if (!(error instanceof ApiError)) return fallback;
  return MESSAGE_ERRORS[error.code] || error.message || fallback;
}
